// Extracts the SKU (part number) from a Garmin buy URL.
// e.g. '/en-US/US/p/575993/pn/010-13226-AK' -> '010-13226-AK'
const skuFromBuyUrl = (url) => url?.match(/\/pn\/([\w-]+)/)?.[1] ?? url;

// Extracts the PID from a Garmin buy URL.
// e.g. '/en-US/US/p/575993/pn/010-13226-AK' -> '575993'
const pidFromBuyUrl = (url) => url?.match(/\/p\/(\d+)/)?.[1] ?? url;

// Convert Filter DropDown List to the new format
export const convertBootstrapFilterDropDownList = (data) => data
  .map(({ text, value, selected }) => ({
    text,
    selected,
    sku: skuFromBuyUrl(value),
    pid: Number(pidFromBuyUrl(value)),
  }))
  .sort((a, b) => (a.sku ?? '').localeCompare(b.sku ?? ''));
